module.exports = __webpack_public_path__ + "ed4f3592995dfbf9cc11dc943bc69925.png";